/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Triggers for step-up authentication */
export enum StepUpTrigger {
  HighRiskAction,
  SensitiveData,
  LargeTransaction,
  NewDevice,
  UnusualLocation,
  TimeBasedRisk,
  BehaviorAnomaly,
}

export type StepUpTriggerArgs = StepUpTrigger;

export function getStepUpTriggerEncoder(): FixedSizeEncoder<StepUpTriggerArgs> {
  return getEnumEncoder(StepUpTrigger);
}

export function getStepUpTriggerDecoder(): FixedSizeDecoder<StepUpTrigger> {
  return getEnumDecoder(StepUpTrigger);
}

export function getStepUpTriggerCodec(): FixedSizeCodec<
  StepUpTriggerArgs,
  StepUpTrigger
> {
  return combineCodec(getStepUpTriggerEncoder(), getStepUpTriggerDecoder());
}
